module.exports = __webpack_public_path__ + "img/full03.f04ed3f8.png";